export default __webpack_public_path__ + "static/media/21.11067ac8.jpg";